import { MainContainerSettings } from 'modules/settingsContainer/MainContainerSettings';
import { ElementContainerSettings } from 'modules/settingsContainer/ElementContainerSettings';
import { SettingsRadio } from 'modules/settingsContainer/SettingsRadio';
import { getActiveRadioValue } from 'modules/settingsContainer/SettingsRadio/constants';
import { GroupContainerSettings } from 'modules/settingsContainer/GroupContainerSettings';
import React from 'react';
import { sortOptions } from 'modules/settingsContainer/common/data/SortByColumnSettings/constants';
import { SortingInterface, SortType } from 'modules/visualisations/Table/visualisation/types';
import { NoopValueType } from 'types/global';

type onChangeType = NoopValueType<{ type: SortType; isActive?: boolean }>;

type SortByColumnSettingsProps = {
  onChange: onChangeType;
  value: SortingInterface;
};

export const SortByColumnSettings = ({ onChange, value }: SortByColumnSettingsProps) => {
  const isActive = !!value;
  return (
    <MainContainerSettings
      titleText="Сортировать по этому столбцу"
      switcherState={isActive}
      switcherChange={() => onChange({ type: 'DESC', isActive: !isActive })}
    >
      <GroupContainerSettings>
        <ElementContainerSettings>
          <SettingsRadio
            onChange={({ value: type }) => onChange({ type })}
            activeValue={getActiveRadioValue(sortOptions, value?.type || 'DESC')}
            options={sortOptions}
          />
        </ElementContainerSettings>
      </GroupContainerSettings>
    </MainContainerSettings>
  );
};
